import { Stack, Typography } from '@mui/material';
import { z } from 'zod';

import { withFieldGroup } from '@/hooks/useAppForm';

interface Values {
  suffix: string;
}
interface ExtraProps {
  prefix: string;
  validate?: boolean;
}

export const RmvField = withFieldGroup<Values, unknown, ExtraProps>({
  defaultValues: { suffix: '' },
  render: ({ group, prefix, validate }) => (
    <Stack alignItems="center" direction="row">
      <group.AppField
        name="suffix"
        {...(validate && {
          validators: {
            onChange: z.string().nonempty(),
          },
        })}
      >
        {(field) => (
          <field.TextField
            label="RMV-Nummer"
            slotProps={{
              input: {
                startAdornment: (
                  <Typography sx={{ color: 'text.secondary', mr: 0.5 }} variant="body1">
                    {prefix}
                  </Typography>
                ),
              },
            }}
          />
        )}
      </group.AppField>
    </Stack>
  ),
});
